interface ShushMarkProps {
  size?: number;
  color?: string;
  accent?: string;
}

// Abstract shield + dot lockup. Matches the mark used in the design canvas
// (see shushvpn.html). The accent dot sits at upper-right to read like the
// "shh" in shushvpn.
export function ShushMark({
  size = 32,
  color = 'var(--ink)',
  accent = 'var(--moss)',
}: ShushMarkProps) {
  const stroke = Math.max(1.4, size * 0.05);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      style={{ display: 'block', flexShrink: 0 }}
      fill="none"
    >
      <path
        d="M16 3c-3 1.6-6 2.5-9 3v10c0 5.6 3.6 9.7 9 11.5 5.4-1.8 9-5.9 9-11.5V6c-3-.5-6-1.4-9-3z"
        stroke={color}
        strokeWidth={stroke}
        strokeLinejoin="round"
      />
      <circle cx="22" cy="9" r="2.6" fill={accent} />
    </svg>
  );
}
